export default __webpack_public_path__ + "static/media/ic-reload.19ea85f5.png";